import { render, staticRenderFns } from "./MediakitProductAdditional.vue?vue&type=template&id=57f50d3b&"
import script from "./MediakitProductAdditional.vue?vue&type=script&lang=js&"
export * from "./MediakitProductAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports